import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector, FormSection, SubmissionError, reset } from 'redux-form';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import agent from '../../agent'
import Countries from '../../data/countries';
import CountryStates from '../../data/states';
import artistType from '../../data/artist-type';
import ArtistPhoto from '../ArtistPhoto'

import _range from 'lodash/range'
import _debounce from 'lodash/debounce'

import renderDatePicker from '../Datepicker';

const renderField = ({ input, className, label, type, meta: { asyncValidating, touched, error, warning } }) => {
  if (touched && error) {
    return (
      <div className={className}>
      <div className="input-field">
        <label className="is-invalid-label">
          <input 
            {...input} 
            type={type}
            className="is-invalid-input" 
            placeholder={label} />
          <span className="form-error is-visible" id="uuid">{error}</span>
          { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
        </label>
      </div>
      </div>
    )
  }
  return (
    <div className={className}>
    <div className="input-field">
      <label>
        <input {...input} placeholder={label} type={type} />
        { asyncValidating && <i className="fa fa-spinner fa-spin"></i> }
      </label>
    </div>
    </div>
  )
}

const validate = {
  required: value => !value && "This field is required",
  radioval: value => !value && console.log("This field is required - hasUnion"),
  password: value => value.length >= 15 && "The field Password must be a string with a maximum length of 15.",
  email: value => !/^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$$/.test(value) && "You have invalid email address"
} //"This field is required",

class AgencyProfileForm extends Component {  
  state = { 
    states: [],
    hasUnion: 'non-union',
    ageFromOptions: this.generateRange(18, 100),
    ageToOptions: this.generateRange(18, 100),
    countries: this.getCountries()
  }

  componentWillMount() {
    const country = this.props.initialValues.artist.country;
    this.setState({
      states: this.props.initialValues.artist.country ? 
        CountryStates.filter(state => state.countryCode === (country || 'US') ) : []
    })
  }

  getStates(value) {
    return this.filterStateByCountry(value)
    // return CountryStates.filter(states => states.countryCode === value || 'US')
  }

  getCountries() {
    return Countries.map(country => ({ value: country.code, label: country.name }) )
  }

  generateRange(start, end, step) {
      return _range(start, end, step).map(i => ({value: i, label: i}))
  }

  goBack = (representation) => {
    console.log('goBack', representation)
    this.props.toggleForm("", representation)
  }

  render() {
    const { handleSubmit, submitting, pristine, error, disableButton, projectId, artistPhoto, initialValues } = this.props
    const paddingFix = {
      paddingLeft: '5rem'
    }
    const paddingP = {
      paddingRight: '1rem',
      marginTop: '0.5rem',
      color: 'rgba(255, 255, 255, 0.6)'
    }
    const paddingB = {
      paddingBottom: '1rem'
    }
    console.log('render-agencyprofileform', initialValues)
    return (
      <form onSubmit={ handleSubmit } className="registartion-profile-form" id="reg-profile-form" >
        <section id="section-profile" className="section gray-bg">
            <div className="grid-x align-center">
              <div className="small-12 medium-9 large-7 cell">
                <FormSection name="artist">
                  <div style={paddingB} className="grid-x">
                    <div className="cell medium-3">
                      <a className="grid-x align-middle" onClick={e => this.goBack(initialValues)}>
                        <span className="cell medium-3 small-3 span-fix fa-stack fa-lg">
                          <i className="fa fa-circle fa-stack-2x"></i>
                          <i className="fa fa-angle-left fa-stack-1x fa-inverse"></i>
                        </span>
                        <p className="cell medium-6 small-6 p-fix">Back to list</p>
                      </a>
                    </div>
                  </div>
                  <div className="grid-x">
                    <div className="cell medium-3">
                      <Field 
                        className="artist-photo-dropzone"
                        name="avatar" 
                        component={ ArtistPhoto }
                        projectid={projectId}
                        artistphoto={artistPhoto}
                        accept="image/jpeg,image/jpg,image/tiff,image/gif" 
                        multiple={ false } 
                      />
                    </div>
                    <div className="cell medium-9">
                      <div className="row">
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* First Name</p>
                          <Field
                            name="first_name"
                            type="text"
                            validate={[validate.required]}
                            component={renderField}
                            label="First Name" />
                        </div>
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* Last Name</p>
                          <Field
                            name="last_name"
                            type="text"
                            validate={[validate.required]}
                            component={renderField}
                            label="Last Name" />
                        </div>
                      </div>

                      <div className="row">
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* Gender</p>
                          <Field 
                            name="gender" 
                            component="select" 
                            placeholder="Select gender">
                              <option key='0' value='male'>Male</option>
                              <option key='1' value='female'>Female</option>
                          </Field>
                        </div>
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* Email</p>
                          <Field
                            name="email"
                            type="email"
                            validate={[validate.email]}
                            component={renderField}
                            label="Email"/>
                        </div>
                      </div>

                      <div className="row">
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* Contact Number</p>
                          <Field
                            name="mobile_number"
                            type="text"
                            component={renderField}
                            label="Contact Number" />
                        </div>
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* Age Category</p>
                          <div className="custom-checkbox">
                            <Field
                              className="styled-checkbox"
                              name="ageCategory"
                              id="minor"
                              value="minor"
                              component="input"
                              type="radio"
                            />
                            <label htmlFor="minor">Minor U18</label>
                          </div>
                          <div className="custom-checkbox">
                            <Field
                              className="styled-checkbox"
                              name="ageCategory"
                              id="adult"
                              value="adult"
                              component="input"
                              type="radio"
                            />
                            <label htmlFor="adult">Adult 18+</label>
                          </div>
                        </div>
                      </div>

                      { this.props.ageCategory === 'adult' &&
                        <div className="row">
                          <div className="small-12 medium-6 column">
                            <p className="edit-label">* Playing Age (From)</p>
                            <Field
                              name="age_from"
                              placeholder="Select age from"
                              component="select"
                              onChange={this.onChangeAgeFrom}>
                              {
                                this.state.ageFromOptions.map((age, idx) => (
                                  <option key={idx + 1}
                                    value={age.value}>{age.label}</option>
                                ))
                              }
                            </Field>
                          </div>

                          <div className="small-12 medium-6 column">
                            <p className="edit-label">* Playing Age (To)</p>
                            <Field 
                              name="age_to"
                              placeholder="Select age to"
                              component="select">
                              {
                                this.state.ageToOptions.map((age, idx) => (
                                  <option key={idx + 1}
                                    value={age.value}>{age.label}</option>
                                ))
                              }
                            </Field>
                          </div>

                        </div>
                      }

                      { this.props.ageCategory === 'child' &&
                        <div className="row">
                          <p className="edit-label">* Date of Birth</p>
                          <Field
                            className="small-12 medium-12 column"
                            name="birth_date"
                            component={renderDatePicker} />
                        </div>
                      }

                      <div className="row">
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* Country</p>
                          <Field 
                              name="country" 
                              placeholder="Please select country"
                              component="select"
                              onChange={ this.onChangeCountry }>
                              {
                                this.state.countries.map((country, idx) => (
                                  <option key={idx + 1}
                                    value={country.value}>{country.label}</option>
                                ))
                              }
                          </Field>
                        </div>
                        {
                          this.state.states.length > 0 ?
                            <div className="small-12 medium-6 column">
                              <p className="edit-label">* States</p>
                              <Field 
                                  name="state" 
                                  placeholder="Please select state"
                                  component="select">
                                  {
                                    this.state.states.map((state, idx) => (
                                      <option key={idx + 1}
                                        value={state.id}>{state.name}</option>
                                    ))
                                  }
                              </Field>
                            </div> : <div></div>
                        }
                      </div>

                      <div className="row">
                        <div className="small-12 medium-6 column">
                          <p className="edit-label">* City</p>
                          <Field
                            name="city"
                            type="text"
                            component={renderField}
                            label="City"/>
                        </div>
                      </div>
                    </div>
                  </div>
                </FormSection>
              </div>
            </div>
        </section>    
        <section className="section">
          <div className="grid-x align-center">
            <div className="small-12 cell text-center">
              <button className="button primary" 
                type="submit" 
                disabled={pristine || submitting || disableButton}>
                  {submitting || disableButton ? 'Saving...' : 'SAVE AND CONFIRM' }
              </button>
            </div>
          </div>
        </section>
      </form>
    )
  }
}

AgencyProfileForm = reduxForm({
  form: 'artistRegistrationWizard3', // <------ same form name
  destroyOnUnmount: false, // <------ preserve form data
  forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
})(AgencyProfileForm)

const mapStateToProps = state => ({
  
});

const mapDispatchToProps = dispatch => ({
  resetForm: () => dispatch(reset('artistRegistrationWizard3')),
  
});

export default connect(mapStateToProps, mapDispatchToProps)(AgencyProfileForm);






// WEBPACK FOOTER //
// ./src/components/agency/AgencyProfileForm.js